module.exports = __webpack_public_path__ + "img/jjcy_1.249d5342.jpg";